
import { defineComponent, nextTick, reactive, ref, toRefs, watch, computed, ComputedRef } from 'vue'
import stocknotesApi from '@/api/stocknotesApi'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import store from '@/store'
import { PlusOutlined } from '@ant-design/icons-vue'
import optionalshares from '@/components/optionalshares.vue'
import globalsets from '@/utils/globalsets'
import Divedit from '@/views/stocknotes/divedit.vue'
const project = require('@/views/stocknotes/project.json')
export default defineComponent({
  components: {
    PlusOutlined,
    optionalshares,
    Divedit
  },
  setup(props: any) {
    type stockType = {
      securityNo: string | number
      securityMarket: string | number
      isTop?: number
      sort?: number
    }
    type notes = {
      Exch: string
      ID: number | string
      Inst: string
      MarketID: number
      Name: string
      PubTime: Date
      Title: string
    }
    type dateOption = {
      label: string
      value: string | number
    }
    type note = {
      Content?: string | null
      Exch?: string
      ID?: number
      Inst?: string
      MarketID?: number
      Name?: string
      PubTime?: number
      Title?: string | null
      TradeDay?: number
      Uid?: string
      ProjectID?: string
      ProjectName?: string
    }
    type pageDataType = {
      radiovalue: number | string
      datevalue: Date | number | string
      text: string
      getCalendarContainer: any | null
      inOptionalData: ComputedRef<stockType> | Array<stockType> | never[]
      token: string
      noteslist: Array<notes>
      currentProject: {
        ProjectID?: string
        ProjectName?: string
        softNameAbbr?: string
      }
      content: string
      dateOptions: dateOption[]
      currentNote: note
    }
    const route = useRoute()
    const pageData: pageDataType = reactive({
      radiovalue: 1,
      datevalue: '',
      text: '',
      getCalendarContainer: (e: HTMLElement) => e.parentNode,
      inOptionalData: [],
      token: '',
      noteslist: [],
      currentProject: {},
      content: '',
      dateOptions: [],
      currentNote: {}
    })
    // 当前产品 ProjectID ProjectName
    pageData.currentProject = project.filter((item: any) => item.softNameAbbr === route.query.softNameAbbr)[0]
    async function gettoken() {
      pageData.token = await globalsets.getToken()
      getlist()
    }
    gettoken()
    pageData.inOptionalData = computed(() => {
      const data = (store.state.OptionalList || []).filter((item: any) => {
        return item.groupType === 0
      })
      // 自选股
      let obj: any = {}
      if (data.length) obj = data[0]
      const result = (obj.stockList || []).map((item: any) => {
        return {
          Exch: item.securityNo,
          Inst: (item.securityMarket || '').toLowerCase(),
          MarketIdD: Number(item.securityNo)
        }
      })
      // const result = obj.stockList
      return result || []
    })
    function getlist() {
      const data: any = {}
      /**
       * Tab:1, 全部
       * Tab:2, 自选，Stock可填多个
       * Tab:3, K线icon，Stock只能传一个，TradeDay必传
       * Tab:4, 当前个股，Stock只能传一个，
       */
      let obj = {}
      if (pageData.radiovalue === 1) {
        obj = {
          Tab: pageData.radiovalue,
          Uid: route.query.uid,
          ProjectID: pageData.currentProject.ProjectID,
          PageID: 1,
          PageSize: 1000
        }
      }
      if (pageData.radiovalue === 2) {
        obj = {
          Tab: pageData.radiovalue,
          Stock: pageData.inOptionalData
        }
      }
      data.data = obj
      data.headers = {
        token: pageData.token
      }
      stocknotesApi.getMsgboardNoteList(data).then((res: any) => {
        const { Data } = res
        pageData.noteslist = Data
        getDate(Data[0])
        getNoteDetail(Data[0].ID)
      })
    }
    // 获取K线交易日
    function getDate(item: any) {
      const data: any = {}
      data.data = {
        Uid: route.query.uid,
        ProjectID: pageData.currentProject.ProjectID,
        Exch: item.Exch,
        Inst: item.Inst
      }
      data.headers = {
        token: pageData.token
      }
      stocknotesApi.getMsgboardNoteTradeDays(data).then((res: any) => {
        const { Data } = res
        pageData.dateOptions = Data.map((d: number) => {
          return {
            label: window.moment(d * 1000).format('YYYY-MM-DD'),
            value: d * 1000
          }
        })
        pageData.datevalue = pageData.dateOptions[0].label
      })
    }
    function getNoteDetail(id: number | string) {
      if (!id) {
        pageData.currentNote = {}
        pageData.content = ''
        return
      }
      const data: any = {}
      data.data = {
        ID: id
      }
      data.headers = {
        token: pageData.token
      }
      stocknotesApi.getMsgboardNote(data).then((res: any) => {
        const { Data } = res
        pageData.currentNote = Data
        pageData.content = Data.Content
      })
    }
    function addnotes() {
      const data: any = {}
      data.data = {
        Uid: '2001',
        ProjectID: pageData.currentProject.ProjectID,
        ProjectName: pageData.currentProject.ProjectName,
        Exch: '',
        Inst: 'GBPJPY',
        MarketID: 123,
        Title: '英镑日元1',
        Content: '<p>很高兴使用该炒股软件</p>',
        TradeDay: 1654444800
      }
      data.headers = {
        token: pageData.token
      }
      // stocknotesApi.getMsgboardCreateNote(data).then((res: any) => {})
    }
    function viewNote(item: any) {
      getDate(item)
      getNoteDetail(item.ID)
    }
    return {
      ...toRefs(pageData),
      addnotes,
      viewNote,
      moment: window.moment
    }
  }
})
